import { useState } from 'react'
import ReCaptcha from 'components/reCaptcha/ReCaptcha'
import CardTitle from 'components/cardTitle/CardTitle'
import FormInput from 'components/formInput/FormInput'
import styles from './AccountRecovery.module.scss'
import { Button } from '@mui/material'
import { RootState, useAppDispatch } from 'store'
import { actions as accountActions } from 'store/account'
import { useSelector } from 'react-redux'

function AccountRecovery(): JSX.Element {
  const dispatch = useAppDispatch()
  const recoverAccountError = useSelector((state: RootState) => state.account.error.recoverAccount)
  const recoveryEmailSent = useSelector((state: RootState) => state.account.recoveryEmailSent)
  const recoverAccountLoading = useSelector((state: RootState) => state.account.loading.recoverAccount)
  const [email, setEmail] = useState('')
  const [captchaVerified, setCaptchaVerified] = useState<boolean>(false)

  const handleInputChange = (event: any) => {
    setEmail(event.target.value)
  }

  const handleSubmit = (event: any) => {
    event.preventDefault()
    dispatch(accountActions.recoverAccount(email))
  }

  return (
    <div className={styles.base}>
      {recoveryEmailSent && (
        <div className={styles.card}>
          <CardTitle data-testid="loginForm"> Account recovery email sent.</CardTitle>
          <div className={styles.cardContent}>
            <p>
              Account recovery email sent to <b>{email}</b>
            </p>
            <p>If you don’t see this email in your inbox within 15 minutes, look for it in your junk mail folder.</p>
            <p>If you find it there, please mark it as “Not Junk”.</p>
          </div>
        </div>
      )}
      {!recoveryEmailSent && (
        <div className={styles.card}>
          <CardTitle data-testid="loginForm">Find Your Account.</CardTitle>
          <div className={styles.cardContent}>
            <div>Please enter your email address and we’ll send you a recovery link.</div>

            <form className={styles.form} onSubmit={handleSubmit}>
              <FormInput required type="email" onChange={handleInputChange} name="email" label="Email" value={email} />
              {recoverAccountError && (
                <div className={styles.error} data-testid="error-text">
                  {recoverAccountError}
                </div>
              )}
              <div className={styles.recaptcha}>
                <ReCaptcha onChange={() => setCaptchaVerified(true)} />
              </div>

              <Button fullWidth variant="contained" type="submit" disabled={!email || recoverAccountLoading || !captchaVerified}>
                Send recovery email
              </Button>
            </form>
          </div>
        </div>
      )}
      <br />
    </div>
  )
}

export default AccountRecovery
